import http, { type ApiEnvelope } from "./http";
import { toFormParams } from "@/utils/form";

export interface UserData {
  id: number;
  email: string;
  phone: string;
  name: string;
  created_at: number;
  updated_at: number;
  deleted_at: number | null;
  remember_token: string;
  api_token: string;
}

export interface EmailBinding {
  id: number;
  email: string;
  uid: number;
  is_invalid: number;
  created_at: number;
  updated_at: number;
  deleted_at: number | null;
}

export interface UserActivationData {
  old_email: string;
  new_email: string;
  user: UserData;
  EmailBinding: EmailBinding;
}

export const emptyUserData = (): UserData => ({
  id: 0,
  email: "",
  phone: "",
  name: "",
  created_at: 0,
  updated_at: 0,
  deleted_at: null,
  remember_token: "",
  api_token: ""
});

export function fetchCurrentUser() {
  return http.get("User") as Promise<ApiEnvelope<UserData | null>>;
}

export function login(email: string, password: string) {
  return http.post(
    "/User/Login",
    toFormParams({ email, password })
  ) as Promise<ApiEnvelope<UserData>>;
}

export function register(payload: {
  name: string;
  email: string;
  phone: string | number;
  password: string;
  password_confirmation: string;
}) {
  return http.post(
    "/User/Register",
    toFormParams(payload)
  ) as Promise<ApiEnvelope<UserData>>;
}

export function retrievePassword(payload: {
  email: string;
  code: string | number;
  password: string;
  password_confirmation: string;
}) {
  return http.post(
    "/User/Retrieve",
    toFormParams(payload)
  ) as Promise<ApiEnvelope<UserData>>;
}

export function sendCode(email: string, template_id = "2") {
  return http.post(
    "/User/Code",
    toFormParams({ email, template_id })
  ) as Promise<ApiEnvelope<Record<string, never>>>;
}

export function activateUser(md5: string) {
  return http.post(
    "/User/Activation",
    toFormParams({ md5 })
  ) as Promise<ApiEnvelope<UserActivationData>>;
}
